import { Injectable, inject } from '@angular/core';

import { DataAnalyticsEvent } from '../../services/data-analytics/data-analytics.domain';
import { DataAnalyticsService } from '../../services/data-analytics/data-analytics.service';

import { W8BenModalName, W8BenTagging, W8BenTaggingFlowType } from './w8ben-form.domain';

@Injectable({
  providedIn: 'root'
})
export class W8BenFormAnalyticsService {
  private readonly dataAnalyticsService = inject(DataAnalyticsService);

  private readonly taggingData: W8BenTagging;
  private modalId: string;

  constructor() {
    this.taggingData = { modalName: W8BenModalName.UPDATE, flow:'n/a' };
  }

  setModalId(value: string): void {
    this.modalId = value;
  }

  getModalId(): string {
    return this.modalId;
  }

  setTaggingData(modalName: W8BenModalName = W8BenModalName.UPDATE, flow?: W8BenTaggingFlowType) : void {
    this.taggingData.modalName = modalName;
    if (flow) {
      this.taggingData.flow = flow;
    }
  }

  emitLinkClickEvent(name: string, useModalName: boolean = true): void {
    const modalName = useModalName && this.taggingData?.modalName ? `${this.taggingData?.modalName}:` : '';
    const flow = this.taggingData.flow !== 'n/a' ? `flow ${this.taggingData.flow}` : 'n/a';
    const eventName = `${modalName}${name}:${flow}`
    this.dataAnalyticsService.emitLinkClickEvent(eventName)
  }

  emitPageChange(event: DataAnalyticsEvent): void {
    this.dataAnalyticsService.emitEvent(event);
  }
}

